import {types} from "mobx-state-tree";
import {nullableBoolean, nullableNumber, nullableString} from "./mstNullable";

// Where a detection came from. AI rows carry a confidence; OCR-extracted and
// reviewer-entered rows do not.
export type DetectionSource = "" | "AI" | "OCR" | "User";

// What the reviewer decided about a detection. Empty until it has been reviewed.
export type DetectionDecision = "" | "Accepted" | "Rejected" | "Edited" | "Added";

// Every optional field below uses the nullable* helpers because the API sends explicit `null`
// for anything it has not populated — the OCR read path never sets confidence/source/decision,
// and the rest map to plain nullable C# strings. See mstNullable.ts.
// `timestamp` and `distance` stay required: they map to non-nullable C# DateTime/double, are
// always serialized, and a detection without them is meaningless.
export const DetectionModel = types.model("Detection", {
  timestamp: types.string,
  text: nullableString(),
  distance: types.number,
  postionFrom: nullableString(),
  positionTo: nullableString(),
  frameUrl: nullableString(),
  // Which extracted frame this was read from. frameUrl is a SAS link that expires, so the index
  // is the only durable handle on the image — it names the file in the pipeline's frames folder,
  // and it is what lets an approved row keep the machine's own frame.
  frameIndex: nullableNumber(),
  main_Code: nullableString(),
  c1: nullableString(),
  c2: nullableString(),
  q1: nullableString(),
  q2: nullableString(),
  sa: nullableString(),
  // True when this detection was added or edited by the user in the OCR app
  // (as opposed to coming straight from the AI/OCR extraction).
  addedByUser: nullableBoolean(),
  // AI confidence 0-1. 0 means "no model score", which is the case for
  // OCR-extracted and reviewer-entered rows.
  confidence: nullableNumber(),
  source: nullableString(),
  decision: nullableString(),
})
